import { defineComponent } from 'vue';
import HomeComponent from '@/components/Home.vue';
export default defineComponent({
    name: 'HomeView',
    props: {},
    components: {
        HomeComponent,
    },
});
